export enum GOOD_DATA_DASHBOARD_IDS {
    DEPOSIT_LEDGER = 'b647196d-277d-42db-a085-cc9fd020e8ac',
    GUEST_LEDGER = 'bb2acff1-aca0-4da7-b670-c74090738e6f',
    CITY_LEDGER = '503d8ab5-e6ac-464a-924d-03faa4ccbefd',
}
